import { createBrowserClient } from "@supabase/ssr";
import { SupabaseClient } from "@supabase/supabase-js";
import type { Database, Json } from "./types";

class Supabase {
  private static instance: Supabase | null = null;
  private supabase: SupabaseClient<Database>;

  constructor() {
    this.supabase = createBrowserClient<Database>(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY!
    );
  }

  static getInstance() {
    if (!Supabase.instance) {
      Supabase.instance = new Supabase();
    }

    return Supabase.instance;
  }

  public getSupabase() {
    return this.supabase;
  }
}

const supabaseInstance = Supabase.getInstance();

/** The raw `embed_pages` row. Admin-side code should prefer `AdminDataset`. */
export type EmbedPageRow = Database["public"]["Tables"]["embed_pages"]["Row"];

/**
 * A dataset as a viewer sees it: the org-scoped rows from `get_embed_pages`,
 * which carry `can_open` alongside the row columns.
 */
export type EmbedPage = Database["public"]["Functions"]["get_embed_pages"]["Returns"][number];

export type DatasetDefaultAccess = Database["public"]["Enums"]["dataset_default_access"];

export default supabaseInstance.getSupabase();
export type { Database as SupabaseDatabase, Json as SupabaseJson };
